/**
 * 文章相关的打点
 * - 文章详情页
 * - 文章首页
 * - 文章列表页
 */

export default {
  /**
   * 文章首页展示
   * @param {*} topbanner 顶部banner是否展示
      yes|有展示;
      no|无展示;
   * @param {*} show 展示内容
      homepage|文章首页展示;
   * @param {*} view 页尾是否展示（不包含底部页尾黑块区域）
      yes|有展示;
      no|无展示;
   * @param {*} area 展示区域
      skill|高效技巧;
      job|职业专题;
      wps|了解wps;
   */
  skillarticleHomepageShow({ topbanner, show, view, area }) {
    this.collect('skillarticle_homepage_show', { topbanner, show, view, area });
  },

  /**
   * 文章首页点击
   * @param {*} click 点击
      topbanner|顶部banner点击;
      content|内容点击;
      topic|专题点击;
      more|查看更多点击;
   * @param {*} area 点击区域
      skill|高效技巧;
      job|职业专题;
      wps|了解wps;
   * @param {*} number banner序号 按banner排列顺序1-2-3-4上报；
   * @param {*} keyword 点击关键字
   * @param {*} type 文章ID
   * @param {*} topic 专题ID
   */
  skillarticleHomepageClick({ click, area, number, keyword, type, topic }) {
    this.collect('skillarticle_homepage_click', {
      click,
      area,
      number,
      keyword,
      type,
      topic,
    });
  },

  /**
   * 文章列表页展示
   * @param {*} show 展示
   */
  listSkillarticleShow({ show }) {
    this.collect('list_skillarticle_show', { show });
  },

  /**
   * 文章列表页点击
   * @param {*} click 点击
      firstclass|上报一级分类关键词;
      number|学习人数;
      time|发布时间;
      collect|收藏人数;
      content|内容点击;
   * @param {*} type 文章ID
   */
  listSkillarticleClick({ click, type }) {
    this.collect('list_skillarticle_click', { click, type });
  },

  /**
   * 文章详情页点击
   * @param {*} click 点击
      collect|收藏;
      praise|点赞;
      wechatshare|微信分享;
      playvideo|视频播放;
      suspendvideo|视频暂停;
      endvideo|播放结束
      link | 按键/超链接点击;
      recommend|点击底部推荐位内容;
      content|详情页内目录点击；
   * @param {*} ranking 视频排序
      按照按键顺序从上到下上报，上报数字1-2-3-4-5-6
   * @param {*} order 按键排序
      按照按键顺序从上到下上报，上报数字1-2-3-4-5-6
   * @param {*} listid 点击文章详情页内右侧技巧时上报
   * @param {*} channel 渠道标识，区分点击来源
   * @param {*} type 教程ID
   * @param {*} source 来源
      simple|简洁版;
      routine|常规版;
   */
  detailsSkillarticleClick({
    click,
    ranking,
    order,
    listid,
    channel,
    type,
    source,
  }) {
    this.collect('details_skillarticle_click', {
      click,
      ranking,
      order,
      listid,
      channel,
      type,
      source,
    });
  },

  /**
   * 文章详情页展示
   * @param {*} show 展示
      link|按键/超链接展示;
      details|详情页;
      recommend|展示底部推荐位内容;
      0.3|文章阅读至30%
      0.5|文章阅读至50%
      0.9|文章阅读至90%
      1|文章阅读至100%
   * @param {*} order 按键排序
      按照按键顺序从上到下上报，上报数字1-2-3-4-5-6
   * @param {*} type 教程ID
   * @param {*} ranking 视频排序
      按照按键顺序从上到下上报，上报数字1-2-3-4-5-6
   * @param {*} channel 渠道标识，区分展示来源
   * @param {*} source 来源
      simple|简洁版;
      routine|常规版;
   */
  detailsSkillarticleShow({ show, order, type, ranking, channel, source }) {
    this.collect('details_skillarticle_show', {
      show,
      order,
      type,
      ranking,
      channel,
      source,
    });
  },

  /**
   * 文章详情页结束
   * @param {*} time 停留时间以秒为单位进行上报
   * @param {*} type 教程ID
   */
  detailsSkillarticleEnd({ time, type }) {
    this.collect('details_skillarticle_end', { time, type });
  },

  /********** Office基础课列表 新埋点 ***********/
  /**
   * 页面的展示 list_base_show
   * @param {*} show：展示
   * base|页面展示;
   */
  officeCourseShow({ show }) {
    this.collect('list_base_show', { show });
  },

  /**
   * 页面的展示 list_base_show
   * @param {*} click：页面点击
   *  class|点击分类关键词;
      tag|点击标签关键词;
      content|点击系列课;
      @param {*} keyword：关键字（click上报class、tag时上报）
      上报分类或标签的关键字
      @param {*} type：系列课ID（click上报content时上报）
   */
   officeCourseClick({ click, keyword, type }) {
    this.collect('list_base_click', { click, keyword, type });
  }
};
